import { useContext } from 'react';
import {
  InputCheckboxGroup,
  InputCheckbox,
  InputTextField
} from '@abbott-components/core';
import Stack from '@mui/material/Stack';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import ControlState from '../../Shared/controlState';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import formatName from '../formatName';
import SizingSelect from '../../Shared/SizingSelect';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);

  const { isReadOnlyView } = state;

  const { schema } = control;

  const properties = schema?.properties as JSONSchema7Properties;

  return (
    <Stack direction="column" spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flexGrow: 4 }}>
          <InputTextField
            name={formatName(properties['label']?.$id as string)}
            label="Text Label"
            isDisabled={isReadOnlyView}
          />
        </Stack>
        <Stack sx={{ flexGrow: 4 }}>
          <InputTextField
            name={formatName(properties['id']?.$id as string)}
            label="ID"
            isDisabled={isReadOnlyView}
          />
        </Stack>
        <Stack sx={{ flexGrow: 1 }}>
          <InputTextField
            name={formatName(properties['maximum']?.$id as string)}
            label="Maximum Characters"
            type="number"
            isDisabled={isReadOnlyView}
          />
        </Stack>
        <SizingSelect
          isReadOnlyView={isReadOnlyView}
          name={formatName(properties['gridSize']?.$id as string)}
        />
      </Stack>
      <Stack direction="row" spacing={2}>
        <InputCheckboxGroup
          name={`${formatName(
            properties['required']?.$id as string
          )}-inputCheckBoxGroup`}
          isDisabled={isReadOnlyView}
        >
          <InputCheckbox
            name={formatName(properties['required']?.$id as string)}
            defaultChecked={
              (properties['required'].default as boolean) ?? false
            }
          >
            Required Field
          </InputCheckbox>
        </InputCheckboxGroup>
        <InputCheckboxGroup
          name={`${formatName(
            properties['isMultiLine']?.$id as string
          )}-inputCheckBoxGroup`}
          isDisabled={isReadOnlyView}
        >
          <InputCheckbox
            name={formatName(properties['isMultiLine']?.$id as string)}
            defaultChecked={
              (properties['isMultiLine'].default as boolean) ?? false
            }
          >
            Allow multi-line input
          </InputCheckbox>
        </InputCheckboxGroup>
      </Stack>
    </Stack>
  );
};
